export function toggleProject(boolean) {
    const header = document.querySelector('.header'),
        projectHead = document.querySelector('.projects__head'),
        projectMain = document.querySelector('.projects__main'),
        projectFoot = document.querySelector('.projects__foot');

    if (boolean) {
        if (window.innerWidth >= 1240) {
            document.body.style.overflow = 'hidden';
            header.classList.add('none');
        }

        projectHead.classList.add('opacity-0', 'hidden');
        projectMain.classList.add('opacity-0', 'hidden');
        projectFoot.classList.remove('opacity-0', 'hidden');
    } else {
        if (window.innerWidth >= 1240) {
            document.body.style.overflow = null;
            header.classList.remove('none');
        }
        projectHead.classList.remove('opacity-0', 'hidden');
        projectMain.classList.remove('opacity-0', 'hidden');
        projectFoot.classList.add('opacity-0', 'hidden');
    }
}
